import { useReducer } from 'react';
import { ConfirmDialogOptions } from '../../../../components';
import { TablePaginatorOptions } from '../../../../utils/consts';
import { DirectionOptions } from '../../../../utils/enums';
import { PageResult, Usuario } from '../../../../utils/models';
import { UserTableColumn } from '../enums/UserTableColumn';
import { ModalRecordUser, UserState } from '../interfaces/interfaces';
import { UserContext } from './UserContext';
import { userReducer } from './userReducer';

const INITIAL_STATE: UserState = {
  userList: [],
  page: 1,
  paginatorOptions: new PageResult<Usuario[]>(),
  rowsPerPage: TablePaginatorOptions.rowsPerPageDefault,
  search: '',
  modalRecord: { show: false, userEdit: new Usuario(), type: 'add' },
  orderBy: UserTableColumn.NOMBRE,
  dir: DirectionOptions.ASC,
  confirmDialog: {
    open: false,
    title: '',
    subTitle: '',
    confirmText: '',
    cancelText: '',
    onConfirm: () => null,
  },
};

interface Props {
  children: JSX.Element | JSX.Element[];
}

export const UserProvider = ({ children }: Props) => {
  const [userState, dispatch] = useReducer(userReducer, INITIAL_STATE);

  const setUserList = (userList: Usuario[]) => {
    dispatch({ type: 'setUserList', userList });
  };

  const setPage = (page: number) => {
    dispatch({ type: 'setPage', page });
  };

  const setStatusUser = (status: boolean) => {
    dispatch({ type: 'setStatusUser', status });
  };

  const setPaginatorOptions = (paginatorOption: PageResult<Usuario[]>) => {
    dispatch({ type: 'setPaginatorOptions', paginatorOption });
  };

  const setRowsPerPage = (rowsPerPage: number) => {
    dispatch({ type: 'setRowsPerPage', rowsPerPage });
  };

  const setModalRecord = (modalRecord: ModalRecordUser) => {
    dispatch({ type: 'setModalRecord', modalRecord });
  };

  const setSearch = (search: string) => {
    dispatch({ type: 'setSearch', search });
  };

  const setOrder = (orderBy: string, dir: DirectionOptions) => {
    dispatch({ type: 'setOrder', orderBy, dir });
  };

  const setConfirmDialog = (confirmDialog: ConfirmDialogOptions) => {
    dispatch({ type: 'setConfirmDialog', confirmDialog });
  };

  return (
    <UserContext.Provider
      value={{
        userState,
        setUserList,
        setPage,
        setStatusUser,
        setPaginatorOptions,
        setRowsPerPage,
        setModalRecord,
        setSearch,
        setOrder,
        setConfirmDialog,
      }}>
      {children}
    </UserContext.Provider>
  );
};
